import {PagedRequest} from "./PagedRequest";

export class ViewVehicleSearch extends PagedRequest{

  public destinatario: string | null;
  public ptoEmision: string | null;
  public transporte: string | null;
  public vinLetras: string | null;
  public vinNumeros: string | null;
  public nroMin: number | null;
  public nroMax: number | null;
  public fecGenDesde: Date | null;
  public fecGenHasta: Date | null;
  public despachoDesde: Date | null;
  public despachoHasta: Date | null;
  public origen: string | null;
  public estado: string | null;

}
